import React from "react";
import {useTranslation} from "react-i18next";

const PaymentChooseUsSection = () =>{
    const {t} =useTranslation('paymentpage');
    return(
        <section className="section-container">
            <div className="payment-choose-us-section">
                <div className="left-payment-choose-us-section">
                    <div className="left-payment-choose-us-section-content">
                         {t('left-payment-choose-us-section.line1')}
                         <p>{t('left-payment-choose-us-section.line2')}</p>
                         <button className="btn-big-desktop btn-mobile">{t('left-payment-choose-us-section-button')}</button>
                    </div>
                </div>
                <div className="right-payment-choose-us-section">
                <div className="right-payment-choose-us-section-content">
                    <div className="right-payment-choose-us-section-content-box1 box-img">
                        <div>
                            <img src="/images/multiple-payment-options.png" alt="card"/>
                        </div>
                        
                            <div className="right-payment-choose-us-section-content-box-title">{t('right-payment-choose-us-section-box1.line1')}</div>
                            <p>{t('right-payment-choose-us-section-box1.line2')}</p>
                        
                    </div>
                    <div className="right-payment-choose-us-section-content-box2  box-img">
                        <div>
                            <img src="/images/recurring-payments.png" alt="recurrence"/>
                        </div>
                        <div className="right-payment-choose-us-section-content-box-title">
                        {t('right-payment-choose-us-section-box2.line1')}
                        </div>
                         
                            <p>{t('right-payment-choose-us-section-box2.line2')}</p>
                    </div>
                    <div className="right-payment-choose-us-section-content-box3 box-img">
                        <div>
                            <img src="/images/customizable-invoices.png" alt="invoice"/>
                        </div>
                        <div className="right-payment-choose-us-section-content-box-title">
                        {t('right-payment-choose-us-section-box3.line1')}
                        </div>
                         <p>{t('right-payment-choose-us-section-box3.line2')}</p>
                    </div>
                    <div className="right-payment-choose-us-section-content-box4 box-img">
                        <div>
                        <img src="/images/fraud-protection.png" alt="invoice"/>
                       </div>
                        <div className="right-payment-choose-us-section-content-box-title">
                        {t('right-payment-choose-us-section-box4.line1')}
                        </div>
                        <p>{t('right-payment-choose-us-section-box4.line2')}</p>

                    </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default PaymentChooseUsSection;